__turbopack_context__.v({
  "checkbox": "checkbox-module-scss-module__spPgwa__checkbox",
});
